import React from "react";
import { Link, useHistory } from "react-router-dom";
import Menu from "../../components/menu/Menu";
// import api from "../../services/api";

export default function ComoFunciona() {
    const [statusPagamento, setStatusPagamento] = React.useState("PENDENTE");
    const history = useHistory();
    React.useEffect(() => {
        document.getElementById("descricao").value = `CPF do Aluno: ${localStorage.getItem(
            "cpf"
        )} E-mail do aluno: ${localStorage.getItem("email")}`;
        document.getElementById("id_transacao").value = `JORNADA#${localStorage.getItem(
            "idUsuario"
        )}#${localStorage.getItem("cpf")}`;
    }, []);
    React.useEffect(() => {
        async function userLoged() {
            try {
                // const res = await api({
                //     method: "get",
                //     url: "me",
                //     headers: { Authorization: `Barer ${localStorage.getItem("token")}` },
                // });
                // setStatusPagamento(res.data.statusPagamento);
                setStatusPagamento('PAGO');
            } catch (error) {
                alert(error.response.data.error);
                history.push("/");
            }
        }
        userLoged();
    }, [history]);
    return (
        <>
            <Menu />
            <div className="App wrapper">
                <main role="main">
                    <div className="jumbotron">
                        <div className="container">
                            <h1 className="display-3">Bem Vindo à Jornada de Acolhimento do Colégio CAVE!</h1>
                            <p>Venha fazer parte de nossa história.</p>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h2 className="titulosPrincipais">Apresentação</h2>
                                <p>Olá,</p>
                                <p>
                                    Que alegria ter você com a gente! <span role="img" aria-label="coração amarelo e coração vermelho">💛❤️</span> Ao participar da <b>Jornada de Acolhimento do Colégio CAVE</b> para os novos alunos do <b>9º ano de 2026</b>, nossa maior expectativa é que você se divirta e viva momentos muito especiais!
                                </p>
                                <p>
                                    Esse processo de acolhimento é um reflexo daquilo que acreditamos e praticamos todos os dias: preparar nossos estudantes para os desafios da vida, reconhecendo no conhecimento a chave para a autonomia, a responsabilidade e, acima de tudo, a felicidade.
                                </p>
                                <p>
                                Nesta <b>2ª fase</b> da Jornada, queremos te conhecer ainda mais!<br/>
                                - Para começar, clique no menu acima, em <b>Etapa 1</b>.
                                </p>
                                <p>
                                    Estamos ansiosos para caminhar junto com você rumo a muitas conquistas, descobertas e sorrisos. Seja bem-vindo(a) à Família CAVE — aqui você vai trilhar o caminho da realização! 
                                </p>
                                <p>Assim que você concluir as três etapas desta fase, entraremos em contato para seguirmos juntos para o próximo passo da Jornada de Acolhimento 2026.</p>
                                <p>Um abraço carinhoso e até breve!</p>
                                <p>Equipe do Colégio CAVE</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <h2 className="titulosPrincipais" style={{ marginTop: "2rem" }}>Perguntas Frequentes (FAQ)</h2>
                                <p>Acesse a seção de Perguntas Frequentes da Jornada de Acolhimento! <Link to={"/duvidas"}>ACESSAR</Link></p>
                            </div>
                        </div>
                        {statusPagamento === "PENDENTE" ? (
                            <div className="row" style={{ marginBottom: "30px" }}>
                                <div className="col-md-12">
                                    <h2 className="titulosPrincipais" style={{ marginTop: "2rem" }}>
                                        Inscrição
                                    </h2>
                                    <p>
                                        A inscrição terá um valor de R$ 20,00 (vinte reais). E deverá ser feita clicando
                                        no botão abaixo:
                                    </p>
                                    <form method="post" action="https://www.moip.com.br/PagamentoSimples.do">
                                        <input type="hidden" name="id_carteira" value="alex@cave.com.br" />
                                        <input type="hidden" name="valor" value="2000" />
                                        <input type="hidden" name="nome" value="JORNADA DE ACOLHIMENTO DO CAVE" />
                                        <input type="hidden" name="descricao" id="descricao" value="" />
                                        <input type="hidden" name="id_transacao" id="id_transacao" value="" />
                                        <input
                                            type="image"
                                            name="submit"
                                            src="https://static.wirecard.com.br/imgs/buttons/bt_pagar_c01_e04.png"
                                            alt="Pagar"
                                            border="0"
                                        />
                                    </form>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                </main>
            </div>
            <footer className="footer">
                <div className="container p-2 text-center">
                    <span className="text-light">Cave 2025 © Todos os direitos reservados.</span>
                </div>
            </footer>
        </>
    );
}
